import { render, staticRenderFns } from "./RecoverPassConfirm.vue?vue&type=template&id=23c78630&"
import script from "./RecoverPassConfirm.vue?vue&type=script&lang=js&"
export * from "./RecoverPassConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports